import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import {
  Box,
  Typography,
  Alert,
  Button,
  Modal,
  Chip,
  TextField,
  Snackbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import axios from "axios";
import { baseURL } from "../Constant";
import "./MyDesignsTable.css";
const MyDesignsTable = () => {
  const {
    instance
  } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const loggedInEnterpriseId = activeAccount?.idTokenClaims?.enterpriseID || "";
  const [designs, setDesigns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openFilesModal, setOpenFilesModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [openHoldModal, setOpenHoldModal] = useState(false);
  const [selectedHoldRow, setSelectedHoldRow] = useState(null);
  const [holdComment, setHoldComment] = useState("");
  const [submittingHold, setSubmittingHold] = useState(false);
  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const showToast = (message, severity = "success") => {
    setToast({
      open: true,
      message,
      severity,
    });
  };

  const handleToastClose = (event, reason) => {
    if (reason === "clickaway") return;

    setToast((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    title: "Confirm Action",
    message: "",
    onConfirm: null,
  });

  const askConfirmation = (
    message,
    onConfirm,
    title = "Confirm Action"
  ) => {
    setConfirmDialog({
      open: true,
      title,
      message,
      onConfirm,
    });
  };

  const handleConfirmAction = async () => {
    const action = confirmDialog.onConfirm;

    setConfirmDialog((prev) => ({
      ...prev,
      open: false,
      onConfirm: null,
    }));

    if (action) {
      await action();
    }
  };

  const handleCancelConfirmation = () => {
    setConfirmDialog((prev) => ({
      ...prev,
      open: false,
      onConfirm: null,
    }));
  };

  const handleCloseFiles = () => {
    setOpenFilesModal(false);
    setSelectedFiles([]);
  };
  const handleDownload = (filePath, fileName) => {
    const url = `${baseURL}/download-file?filePath=${encodeURIComponent(filePath)}`;
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
  };
  useEffect(() => {
    if (!loggedInEnterpriseId) return;
    fetchMyDesigns();
  }, [loggedInEnterpriseId]);
  const fetchMyDesigns = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${baseURL}/my-designs/${loggedInEnterpriseId}`);
      setDesigns(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDesignAction = async (row, status) => {
    const campaignId = row.campaign_id;

    if (status === "design_on_hold") {
      setSelectedHoldRow(row);
      setHoldComment("");
      setOpenHoldModal(true);
      return;
    }

    if (!campaignId) {
      showToast("Campaign ID is missing for this design.", "error");
      return;
    }

    const actionMessages = {
      design_started:
        row.status === "design_on_hold"
          ? "Resume working on this design?"
          : "Start working on this design?",
      design_on_hold: "Put this design on hold?",
      design_ended: "Mark this design as ended?",
    };

    askConfirmation(
      actionMessages[status],
      async () => {
        try {
          await axios.post(`${baseURL}/campaign-design/update-status`, {
            id: campaignId,
            status,
            actionBy: loggedInEnterpriseId,
          });

          const successMessages = {
            design_started:
              row.status === "design_on_hold"
                ? "Design resumed successfully."
                : "Design started successfully.",
            design_on_hold: "Design put on hold successfully.",
            design_ended: "Design ended successfully.",
          };

          showToast(successMessages[status] || "Design updated successfully.", "success");

          await fetchMyDesigns();
        } catch (err) {
          console.error("Failed to update design:", err);

          showToast(err.response?.data?.message || "Failed to update design.", "error");
        }
      },
      "Confirm Design Action"
    );
  };

  const handleOpenFiles = files => {
    const validFiles = files?.filter(f => f.file_name) || [];
    setSelectedFiles(validFiles);
    setOpenFilesModal(true);
  };


  const columns = [
    {
      field: "id",
      headerName: "SI#",
      minWidth: 60,
      sortable: false,
      flex: 0.4,
      renderCell: (params) =>
        params.api.getSortedRowIds().indexOf(params.id) + 1,
      headerClassName: "left-align-header",
      cellClassName: "left-cell",
    },
    {
      field: "program_name",
      headerName: "Program Name",
      minWidth: 160,
      flex: 1,
      headerClassName: "center-header",
      cellClassName: "left-cell",
    },
    {
      field: "market",
      headerName: "Market",
      minWidth: 110,
      flex: 1,
      headerClassName: "center-header",
      cellClassName: "left-cell",
    },
    {
      field: "collateral_type",
      headerName: "Collateral Type",
      minWidth: 140,
      flex: 1,
      headerClassName: "center-header",
      cellClassName: "left-cell",
    },
    {
      field: "no_of_collaterals",
      headerName: "# Collaterals",
      minWidth: 110,
      flex: 0.7,
      headerClassName: "center-header",
      cellClassName: "left-cell",
    },
    {
      field: "start_date",
      headerName: "Start Date",
      minWidth: 120,
      flex: 0.8,
      headerClassName: "center-header",
      cellClassName: "left-cell",
      renderCell: (params) =>
        params.row.start_date
          ? new Date(params.row.start_date).toLocaleDateString("en-GB")
          : "—",
    },
    {
      field: "end_date",
      headerName: "End Date",
      minWidth: 120,
      flex: 0.8,
      headerClassName: "center-header",
      cellClassName: "left-cell",
      renderCell: (params) =>
        params.row.end_date
          ? new Date(params.row.end_date).toLocaleDateString("en-GB")
          : "—",
    },
    {
      field: "assigned_by",
      headerName: "Assigned By",
      minWidth: 140,
      flex: 1,
      headerClassName: "center-header",
      cellClassName: "left-cell",
      renderCell: (params) => params.value?.trim() || "—",
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 130,
      flex: 0.8,
      sortable: false,
      headerClassName: "center-header",
      cellClassName: "left-cell",
      renderCell: (params) => {
        const statusMap = {
          assigned: "Assigned",
          design_started: "Design Started",
          design_on_hold: "Design on Hold",
          design_ended: "Design Ended",
          completed: "Completed",
          rejected: "Rejected",
        };

        return statusMap[params.row.status] || params.row.status || "—";
      },
    },
    {
      field: "hold_comment",
      headerName: "Hold Reason",
      minWidth: 220,
      flex: 1,
      sortable: false,
      headerClassName: "center-header",
      cellClassName: "left-cell",
      renderCell: (params) => (
        <Typography
          variant="body2"
          sx={{
            whiteSpace: "normal",
            overflowWrap: "anywhere",
            py: 1,
          }}
        >
          {params.row.hold_comment || "—"}
        </Typography>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 300,
      flex: 1.5,
      sortable: false,
      headerClassName: "center-header",
      cellClassName: "left-cell",
      renderCell: (params) => {
        const row = params.row;

        if (row.status === "assigned") {
          return (
            <div className="migrated-style-designtable-1ab3f2-16">
              <Button
                variant="contained"
                size="small"
                onClick={() => handleDesignAction(row, "design_started")}
              >
                Start Design
              </Button>
              <Button
                variant="outlined"
                size="small"
                onClick={() => handleDesignAction(row, "design_on_hold")}
              >
                Hold Design
              </Button>
            </div>
          );
        }

        if (row.status === "design_started") {
          return (
            <div className="migrated-style-designtable-1ab3f2-16">
              <Button
                variant="contained"
                size="small"
                onClick={() => handleDesignAction(row, "design_ended")}
              >
                End Design
              </Button>
              <Button
                variant="outlined"
                size="small"
                onClick={() => handleDesignAction(row, "design_on_hold")}
              >
                Hold Design
              </Button>
            </div>
          );
        }

        if (row.status === "design_on_hold") {
          return (
            <Button
              variant="contained"
              size="small"
              onClick={() => handleDesignAction(row, "design_started")}
            >
              Resume Design
            </Button>
          );
        }

        if (row.status === "design_ended") {
          return <Chip label="Awaiting Admin Review" size="small" />;
        }

        if (row.status === "completed") {
          return <Chip label="Completed" color="success" size="small" />;
        }

        if (row.status === "rejected") {
          return <Chip label="Rejected" color="error" size="small" />;
        }

        return "—";
      },
    },
    {
      field: "files",
      headerName: "Files",
      minWidth: 90,
      flex: 0.6,
      sortable: false,
      headerClassName: "center-header",
      cellClassName: "left-cell",
      renderCell: (params) => {
        const files = params.row.files?.filter((f) => f.file_name) || [];

        return (
          <Button
            variant="outlined"
            size="small"
            disabled={files.length === 0}
            onClick={() => handleOpenFiles(files)}
            sx={{ textTransform: "none" }}
          >
            {files.length > 0 ? `${files.length} Files` : "No Files"}
          </Button>
        );
      },
    },
  ];

  const handleHoldSubmit = async () => {
    const comment = holdComment.trim();

    if (!comment) {
      showToast("Please enter a reason for putting the design on hold.", "warning");
      return;
    }

    if (!selectedHoldRow?.campaign_id) {
      showToast("Campaign ID is missing for this design.", "error");
      return;
    }

    askConfirmation(
      "Are you sure you want to put this design on hold?",
      async () => {
        setSubmittingHold(true);

        try {
          await axios.post(`${baseURL}/campaign-design/update-status`, {
            id: selectedHoldRow.campaign_id,
            status: "design_on_hold",
            actionBy: loggedInEnterpriseId,
            comment
          });

          showToast("Design put on hold successfully.", "success");

          setOpenHoldModal(false);
          setSelectedHoldRow(null);
          setHoldComment("");

          await fetchMyDesigns();
        } catch (err) {
          console.error("Failed to put design on hold:", err);

          showToast(
            err.response?.data?.message || "Failed to put design on hold.",
            "error"
          );
        } finally {
          setSubmittingHold(false);
        }
      },
      "Confirm Hold"
    );
  };

  return <>
    {loading && <Alert severity="info" sx={{
      mb: 2
    }}>
      Loading your designs...
    </Alert>}

    {!loading && designs.length === 0 ? <Box sx={{
      textAlign: "center",
      marginTop: "100px"
    }}>
      <Typography variant="h6">
        No designs assigned to you yet
      </Typography>
    </Box> : <div className="migrated-style-mydesignstable-b8408d-10">

      <DataGrid
        rows={designs}
        columns={columns}
        loading={loading}
        getRowId={(row) => row.campaign_id ?? row.id}
        pageSize={10}
        rowsPerPageOptions={[10]}
        disableSelectionOnClick
        disableColumnMenu
        sortingOrder={["asc", "desc"]}

        sx={{
          width: "100%",
          height: "100%",
          border: "none",

          "& .MuiDataGrid-columnHeader": {
            backgroundColor: "#022278",
            color: "#fff",
          },

          "& .MuiDataGrid-columnHeaderTitleContainer": {
            textAlign: "left",
            justifyContent: "flex-start"
          },

          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: 500,
          },

          "& .MuiDataGrid-sortIcon": {
            color: "#fff",
          },

          "& .MuiDataGrid-menuIconButton": {
            color: "#fff",
          },

          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#022278",
          },

          "& .MuiDataGrid-row": {
            backgroundColor: "#fff",
          },

          "& .MuiDataGrid-cell": {
            display: "flex",
            alignItems: "center",
          },
        }}
        slots={{
          toolbar: GridToolbarQuickFilter,
        }}
      />
    </div>}

    <Modal open={openFilesModal} onClose={handleCloseFiles}>
      <Box sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "400px",
        bgcolor: "white",
        borderRadius: 3,
        boxShadow: 24,
        p: 3
      }}>
        <Typography variant="h6" mb={2}>
          Attached Files
        </Typography>

        {selectedFiles.length === 0 ? <Typography color="text.secondary">
          No files available
        </Typography> : <Box sx={{
          maxHeight: "300px",
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          gap: 1
        }}>
          {selectedFiles.map(file => <Box key={file.id} sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            border: "1px solid #eee",
            borderRadius: "10px",
            p: 1.2,
            "&:hover": {
              backgroundColor: "#f9f9f9"
            }
          }}>
            <Typography sx={{
              fontSize: "13px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "220px"
            }}>
              {file.file_name}
            </Typography>

            <Button size="small" variant="contained" onClick={() => handleDownload(file.file_path, file.file_name)} sx={{
              textTransform: "none",
              fontSize: "12px"
            }}>
              Download
            </Button>
          </Box>)}
        </Box>}

        <Box mt={2} textAlign="right">
          <Button onClick={handleCloseFiles}>Close</Button>
        </Box>
      </Box>
    </Modal>

    <Modal
      open={openHoldModal}
      onClose={() => {
        if (!submittingHold) {
          setOpenHoldModal(false);
          setSelectedHoldRow(null);
          setHoldComment("");
        }
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: 450 },
          bgcolor: "white",
          borderRadius: 3,
          boxShadow: 24,
          p: 3
        }}
      >
        <Typography variant="h6" mb={1}>
          Put Design on Hold
        </Typography>

        <Typography variant="body2" color="text.secondary" mb={2}>
          Please specify why this design is being put on hold.
        </Typography>

        <TextField
          fullWidth
          multiline
          minRows={3}
          maxRows={6}
          required
          label="Reason for Hold"
          placeholder="Enter the reason..."
          value={holdComment}
          onChange={(e) => setHoldComment(e.target.value)}
          inputProps={{ maxLength: 2000 }}
          disabled={submittingHold}
        />

        <Box
          display="flex"
          justifyContent="flex-end"
          gap={1}
          mt={3}
        >
          <Button
            onClick={() => {
              setOpenHoldModal(false);
              setSelectedHoldRow(null);
              setHoldComment("");
            }}
            disabled={submittingHold}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={handleHoldSubmit}
            disabled={submittingHold || !holdComment.trim()}
          >
            {submittingHold ? "Submitting..." : "Confirm Hold"}
          </Button>
        </Box>
      </Box>
    </Modal>

    <Snackbar
      open={toast.open}
      autoHideDuration={3000}
      onClose={handleToastClose}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <MuiAlert
        elevation={6}
        variant="filled"
        onClose={handleToastClose}
        severity={toast.severity}
        sx={{ width: "100%" }}
      >
        {toast.message}
      </MuiAlert>
    </Snackbar>

    <Dialog
      open={confirmDialog.open}
      onClose={handleCancelConfirmation}
      fullWidth
      maxWidth="xs"
      aria-labelledby="confirmation-dialog-title"
    >
      <DialogTitle id="confirmation-dialog-title">
        {confirmDialog.title}
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          {confirmDialog.message}
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ p: 2, pt: 1 }}>
        <Button
          onClick={handleCancelConfirmation}
          color="inherit"
          disabled={submittingHold}
        >
          Cancel
        </Button>

        <Button
          onClick={handleConfirmAction}
          variant="contained"
          autoFocus
          disabled={submittingHold}
        >
          {submittingHold ? "Submitting..." : "Confirm"}
        </Button>
      </DialogActions>
    </Dialog>
  </>;
};
export default MyDesignsTable;
